<ng-container
  *ngIf="additionalDocumentTypes && inputs.ResidentType.options.length > 0; else loading">
  <form [formGroup]="form" (ngSubmit)="submit()">
    <svg
      class="mb-2"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M8.91406 14.4004H15.0855V23.3147H8.91406V14.4004Z" fill="#E6F4FA" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.22876 14.4476C8.22876 14.0418 8.56647 13.7129 8.98305 13.7129H15.0173C15.4339 13.7129 15.7716 14.0418 15.7716 14.4476V23.2639C15.7716 23.6697 15.4339 23.9986 15.0173 23.9986H8.98305C8.56647 23.9986 8.22876 23.6697 8.22876 23.2639V14.4476ZM9.73733 15.1823V22.5292H14.263V15.1823H9.73733Z"
        fill="#FF8726" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.1768 1.56219C12.078 1.46981 11.922 1.46981 11.8232 1.56219L1.61046 11.1128C1.56028 11.1597 1.53191 11.2245 1.53191 11.2923V22.2583C1.53191 22.3957 1.64623 22.5071 1.78723 22.5071H22.2128C22.3538 22.5071 22.4681 22.3957 22.4681 22.2583V11.2923C22.4681 11.2245 22.4397 11.1597 22.3895 11.1128L12.1768 1.56219ZM10.7626 0.485012C11.4541 -0.161672 12.5459 -0.16167 13.2374 0.485013L23.4502 10.0356C23.8014 10.364 24 10.8179 24 11.2923V22.2583C24 23.2202 23.1998 24 22.2128 24H1.78723C0.800173 24 0 23.2202 0 22.2583V11.2923C0 10.8179 0.198558 10.364 0.549789 10.0356L10.7626 0.485012Z"
        fill="#1195FF" />
    </svg>
    <app-radio
      class="resident-type"
      fullWidth="true"
      inline="true"
      [formGroup]="form"
      [isSubmitted]="isSubmitted"
      [options]="inputs.ResidentType"></app-radio>
    <lib-mt-breadcrumb
      *ngIf="residentTypeSelected === hostedOptionID"
      class="breadcrumb-small"
      [options]="optionsBreadcrumb"
      [activeAutoChangeStep]="false"></lib-mt-breadcrumb>
    <lib-mt-selector
      *ngIf="residentTypeSelected !== hostedOptionID"
      (changeEvent)="onTypeChange($event)"
      [fullWidth]="true"
      [formGroup]="form"
      [isSubmitted]="isSubmitted"
      [options]="inputs.Type"></lib-mt-selector>
    <br />
    <ng-container [ngSwitch]="residentTypeSelected" *ngIf="residentTypeSelected > 0">
      <div *ngSwitchCase="hostedOptionID" class="container-info">
        <svg
          height="20"
          width="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.99957 0.0390625C4.49797 0.0390625 0.0385742 4.49846 0.0385742 10.0001C0.0385742 15.5017 4.49797 19.9611 9.99957 19.9611C15.5012 19.9611 19.9606 15.5017 19.9606 10.0001C19.9606 4.49846 15.5012 0.0390625 9.99957 0.0390625ZM9.86286 3.69146C10.6863 3.69146 11.3519 4.35708 11.3519 5.18052C11.3519 6.00396 10.6863 6.66958 9.86286 6.66958C9.03942 6.66958 8.3738 6.00396 8.3738 5.18052C8.3738 4.35708 9.03942 3.69146 9.86286 3.69146ZM12.1879 16.3087H7.81126V14.536H8.78392V9.3742H8.69642C8.20892 9.3742 7.81126 8.97966 7.81126 8.48904C7.81126 8.00154 8.2058 7.60388 8.69642 7.60388H11.2206V14.5359H12.1886L12.1879 16.3087Z"
            fill="#1195FF" />
        </svg>

        <div *ngIf="active[0]" class="info">
          {{ 'M_PAC_ENROLLMENT_HOSTED_STEP1_DOCS_PROOF' | translate }}
        </div>
        <div *ngIf="active[1]" class="info__adjust">
          {{ 'M_PAC_ENROLLMENT_HOSTED_STEP2_DOCS_PROOF' | translate }}
        </div>
        <div *ngIf="active[2]" class="info">
          <div>&bull; {{ 'M_PAC_ENROLLMENT_HOSTED_STEP3_DOCS_PROOF' | translate }}</div>
          <div>&bull; {{ 'M_PAC_ENROLLMENT_TENANT_STEP_DOCS_PROOF' | translate }}</div>
          <div>&bull; {{ 'M_PAC_ENROLLMENT_OWNER_STEP_DOCS_PROOF' | translate }}</div>
        </div>
      </div>
      <div *ngSwitchDefault class="container-info">
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.99957 0.0390625C4.49797 0.0390625 0.0385742 4.49846 0.0385742 10.0001C0.0385742 15.5017 4.49797 19.9611 9.99957 19.9611C15.5012 19.9611 19.9606 15.5017 19.9606 10.0001C19.9606 4.49846 15.5012 0.0390625 9.99957 0.0390625ZM9.86286 3.69146C10.6863 3.69146 11.3519 4.35708 11.3519 5.18052C11.3519 6.00396 10.6863 6.66958 9.86286 6.66958C9.03942 6.66958 8.3738 6.00396 8.3738 5.18052C8.3738 4.35708 9.03942 3.69146 9.86286 3.69146ZM12.1879 16.3087H7.81126V14.536H8.78392V9.3742H8.69642C8.20892 9.3742 7.81126 8.97966 7.81126 8.48904C7.81126 8.00154 8.2058 7.60388 8.69642 7.60388H11.2206V14.5359H12.1886L12.1879 16.3087Z"
            fill="#1195FF" />
        </svg>
        <div
          class="info"
          [class.info__adjust]="
            inputs.ResidentType.options[1]['IdAcceptanceCode'] === residentTypeSelected
          ">
          {{
            (inputs.ResidentType.options[1]['IdAcceptanceCode'] === residentTypeSelected
              ? 'M_PAC_ENROLLMENT_TENANT_STEP_DOCS_PROOF'
              : 'M_PAC_ENROLLMENT_OWNER_STEP_DOCS_PROOF'
            ) | translate
          }}
        </div>
      </div>
    </ng-container>

    <br />

    <app-image-uploader
      [fullWidth]="true"
      [formGroup]="form"
      [isSubmitted]="isSubmitted"
      [options]="inputs.file1"></app-image-uploader>
  </form>
</ng-container>
<ng-template #loading>
  <app-skeleton-loader
    [selector]="'text-center'"
    [isList]="true"
    [listParams]="[
      { w: '20px', h: '20px' },
      { w: '25%', h: '16px', mb: '12px' }
    ]"></app-skeleton-loader>
  <app-skeleton-loader
    [selector]="'text-center'"
    [isHorizontal]="true"
    [border]="null"
    [listParams]="[
      { w: '20px', h: '20px', type: 'circle' },
      { w: '50px', h: '16px', mr: '8%' },
      { w: '20px', h: '20px', type: 'circle' },
      { w: '50px', h: '16px', mr: '8%' },
      { w: '20px', h: '20px', type: 'circle' },
      { w: '50px', h: '16px' }
    ]"></app-skeleton-loader>
  <app-skeleton-loader
    [isList]="true"
    [listParams]="[
      { w: '10%', h: '20px' },
      { w: '100%', h: '40px', mb: '12px' },
      { w: '18%', h: '20px' },
      { w: '100%', h: '200px', br: '8px' }
    ]"></app-skeleton-loader>
</ng-template>
